import React, { useState, useEffect, useRef } from "react";
import s from "../Afiliaciones.module.scss";
import Widget from '../../../components/Widget';
class Images extends React.Component{
    state = {
        data : []
    }

   render() {
       console.log(this.props.data)
       return(
           <div className={s.root}>
               <h3 className="page-title mb-lg"><span className="fw-semi-bold">Evidencias guardadas</span></h3>
               <Widget >
                   {this.props.data !== 0 && this.props.data[0] !== null &&
                       <div>
                           {this.props.data.map((item, index) =>(
                               <img name= {"foto"+index} src={process.env.PUBLIC_URL+"/uploads/" + item} height="400px" width="400px"
                                    style={{
                                        border: '10px solid #555',
                                        }}
                               ></img>
                       ))}
                       </div>
                   }
                   {this.props.data[0] === null &&
                       <div>
                           <p>No hay fotos disponibles</p>
                       </div>
                   }
               </Widget>
           </div>
       );
   }
}

export default Images;